import { useEffect } from "react";
import { useLocation, Link } from "react-router-dom";
import { Reveal } from "../lib/motion";
import { MascotWelcome } from "../components/Mascot";
import { useRequestDialog } from "../components/RequestDialog";
import { usePageMeta } from "../lib/seo";
import { SERVICES } from "../content/defaults";

export default function RequestPage({ appointment }) {
  const openDialog = useRequestDialog();
  const loc = useLocation();

  usePageMeta(appointment ? "Request an Appointment | C.C.C. Auto Electric" : "Describe Your Repair | C.C.C. Auto Electric",
    "Send your vehicle details and symptoms to the shop. You get a REQ- reference and the shop confirms availability — preferred dates are requests, not bookings.");

  useEffect(() => {
    const params = new URLSearchParams(loc.search);
    const service = params.get("service");
    const map = { "battery-charging": "Battery & charging concern", "wiring-lighting": "Lights & wiring concern", "starting-alternator": "Starter & alternator concern" };
    openDialog(service ? map[service] || "Electrical diagnosis" : "Electrical diagnosis", "", appointment);
    // eslint-disable-next-line
  }, []);

  return (
    <main>
      <section className="hero">
        <div className="container" style={{ maxWidth: 760 }}>
          <MascotWelcome badge={appointment ? "Appointment request" : "Repair request"} size={170}
            heading={appointment ? "Request an appointment" : "Describe your repair"}
            text="The form is open for you. Share your vehicle details, symptoms and how to reach you — the shop contacts you to confirm availability."
            onCta={() => openDialog("Electrical diagnosis", "", appointment)} />
          <div className="card" style={{ padding: 26, marginTop: 30 }}>
            <h3 style={{ fontSize: 17, marginBottom: 12 }}>What happens after you send it</h3>
            <ol className="muted" style={{ margin: 0, paddingLeft: 20, lineHeight: 1.9, fontSize: 14.5 }}>
              <li>You get a REQ- reference number for your records.</li>
              <li>Staff review the request and contact you by phone or email.</li>
              <li>Only staff confirm an appointment — preferred dates are requests.</li>
            </ol>
          </div>
          <p className="form-note" style={{ marginTop: 20 }}>
            Explore the services first: {SERVICES.map((s, i) => (
              <span key={s.id}>{i > 0 && " · "}<Link to={`/services/${s.id}`} style={{ color: "var(--blue-bright)" }}>{s.title}</Link></span>
            ))}
          </p>
        </div>
      </section>
    </main>
  );
}
